import {applyMiddleware, createStore} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducer";
import cartValidator from "./middlewares/cartValidator";


const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(cartValidator)));

export default store;
